export enum DataStatus {
  Uninitialized = 0,
  Waiting = 1,
  Error = 2,
  Ok = 3,
}

export enum AuthStatus {
  Unauthenticated = 0,
  Unauthorized = 1,
  Authorized = 2,
  AuthorizedTemporaryPassword = 3,
  Uninitialized = 4,
}

export enum Roles {
  MetadataAdmin = 'MetadataAdmin',
  ViewExport = 'ViewExport',
  Import = 'Import',
  Administrator = 'Administrator',
  Versioning = 'Versioning',
  Sekretess = 'Security',
}

export interface User {
  id: number;
  name: string;
  username: string;
  roles: Roles[];
  locked: boolean;
  temporaryPassword: boolean;
}

export interface Jwt {
  sub: string;
  iat: number;
  exp: number;
  user: User;
}
